export default {
    methods: {
        validateSearch: function(value) {
            let white = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-._ "

            if (value == '') {
                return true
            }
            for (var x = 0; x < value.length; x++)
            {
                var c = value.charAt(x);
                if (white.indexOf(c) < 0) {
                    return false;
                }
            }
            return true;
        },
        validateLength: function(value, min, max, isRequired){
            let result = true;

            if (!value) {
                value = "";
            }

            if (isRequired) {
                result = this.validateRequired(value, isRequired);
            }
            else {
                if (value.trim() == "") {
                    return true;
                }
            }

            if (result) {
                if (value.length < min || value.length > max) {
                    result = false;
                }
            }
            return result;
        },
        validateRequired: function(value, zeroNotOk) {
            if (!value) {
                return false;
            }
            if (value.trim() == "" || (value.trim() == "0" && zeroNotOk)) {
                return false;
            }
            else {
                return true;
            }
        },
        validateNumber: function(value, isRequired) {
            let result = true;
            if (!value) {
                value = "";
            }
            if (isRequired && value.trim() == "") {
                result = false;
            }
            else if (value == "") {
                return true;
            }
            if (result && value.trim() != "") {
                var re = /^(0|[1-9][0-9]*)$/;
                result = this.validateRegularExpression(re, value);
            }
            return result;
        },
        validatePhone: function (phone, isRequired) {
            let result = true;
            let cleanedPhone = "";
            if (!phone) {
                cleanedPhone = '';
            }
            else
            {
                cleanedPhone = phone;
            }

            cleanedPhone = cleanedPhone.replace(/\+/gi,'').replace(/-/gi,'').replace(/\(/gi,'').replace(/\)/gi,'').replace(' ','').trim();
            if (isRequired) {
                result = this.validateRequired(cleanedPhone,true);
            }
            if (result && cleanedPhone != "") {
                var re = /^\d{10}$/;
                result = this.validateRegularExpression(re, cleanedPhone);
            }

            return result;
        },
        validAddress: function(value, isRequired) {
            let result = true;
            if (!value) {
                value = "";
            }
            if (isRequired) {
                result = this.validateRequired(value,false);
            }
            if (result && value.trim() != "") {
                var regex = /^[a-zA-Z0-9][a-zA-Z0-9- .,#;]*$/
                var test = value.toLowerCase();
                result = this.validateRegularExpression(regex, test);
            }
            return result;
        },
        stripNonNumeric: function(value) {
            let white = "0123456789"
            var result = ''
            if (!value || value == '') {
                return value;
            }
            for (var x = 0; x < value.length; x++)
            {
                var c = value.charAt(x);
                if (white.indexOf(c) >= 0) {
                    result = result + c;
                }
            }
            return result;
        },
        validNumber: function(value, isRequired, canIncludeText) {
            let result = true;
            if (!value) {
                value = "";
            }

            if (isRequired) {
                result = this.validateRequired(value, false);
            }
            if (result) {
                result = this.validateNumber(value, false);
            }
            if (canIncludeText && !result) {
                result = this.validText(value, false, true);
            }
            return result;
        },
        validText: function(value, isRequired, canStartWithNumber, canIncludeApostrophe=false ) {
            let result = true;
            if (!value) {
                value = "";
            }
            if (!isRequired && _.isNullOrEmpty(value))
            {
                return true;
            }
            if (isRequired) {
                result = this.validateRequired(value, true);
            }

            // if (result)
            // {
            //     if (this.validateNumber(value, false)) {
            //         result = false;
            //     }
            // }
            var regex = /^[a-z]+[a-z0-9- .,#;]*$/
            if(canIncludeApostrophe && !canStartWithNumber && _.size(value) > 0) {
                regex = /^[a-z]+[a-z0-9- .,#;']*$/
            } else if (canIncludeApostrophe && canStartWithNumber &&  _.size(value) > 0) {
                regex = /^([0-9]+([ ]+[a-z]+|[a-z]+)|[a-z]+)[a-zA-Z0-9- .,#;']*$/
            } else if (canStartWithNumber && _.size(value) > 0) {
                regex = /^([0-9]+([ ]+[a-z]+|[a-z]+)|[a-z]+)[a-zA-Z0-9- .,#;]*$/
            } //else {
            //     regex = /^[a-z]+$/
            // }
            if (result && !_.isNullOrEmpty(value)) {
                var test = value.toLowerCase();
                result = regex.test(test);
            }
            return result;
        },
        validateURL: function(url, isRequired) {
            let result = true;
            if (!url) {
                url = "";
            }
            if (isRequired) {
                result = this.validateRequired(url, true);
            }
            if (result && url.trim() != "") {
                var re = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/
                var test = url.toLowerCase();
                if (test.endsWith(".js") || test.endsWith(".exe") || test.endsWith(".bat") || test.endsWith(".javascript")) {
                    result = false;
                }
                else {
                    result = this.validateRegularExpression(re, test);
                }
            }
            return result;
        },
        validateEmail: function (email, isRequired) {
            let result = true;
            if (!email) {
                email = "";
            }
            if (isRequired) {
                result = this.validateRequired(email,true);
            }
            if (result && email.trim() != "") {
                var re =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                result = this.validateRegularExpression(re, email);
            }
            return result;
        },
        validateRegularExpression: function (expression, value) {
            if (!value) {
                value = "";
            }
            if (expression.test(value)) {
                return true;
            }
            else {
                return false;
            }
        },
        validateBooleanExpression: function (expression) {
            if (!expression) {
                return false;
            }
            return expression;
        }
    }
};